import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBigUp, ArrowBigDown } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ENDPOINTS = {
  blog: (id) => `/blog/${id}/vote`,
  thread: (id) => `/community/threads/${id}/vote`,
  comment: (id) => `/comments/${id}/vote`,
};

export default function VoteButtons({ type, item, orientation = "vertical" }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [score, setScore] = useState(item.score ?? 0);
  const [myVote, setMyVote] = useState(item.my_vote ?? 0);
  const [busy, setBusy] = useState(false);

  const cast = async (value) => {
    if (!user) {
      toast.error("Please log in to vote");
      navigate("/login");
      return;
    }
    const next = myVote === value ? 0 : value;
    setBusy(true);
    try {
      const { data } = await api.post(ENDPOINTS[type](item.id), { value: next });
      setScore(data.score);
      setMyVote(data.my_vote);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const wrap = orientation === "vertical" ? "flex-col" : "flex-row";
  return (
    <div className={`flex ${wrap} items-center gap-1 select-none`} data-testid={`vote-${type}-${item.id}`}>
      <button
        data-testid={`upvote-${type}-${item.id}`}
        disabled={busy}
        onClick={(e) => { e.preventDefault(); cast(1); }}
        className={`p-1 rounded-md transition-colors ${myVote === 1 ? "text-emerald-400" : "text-slate-400 hover:text-emerald-400"}`}
      >
        <ArrowBigUp className={`w-5 h-5 ${myVote === 1 ? "fill-emerald-400" : ""}`} />
      </button>
      <span
        data-testid={`score-${type}-${item.id}`}
        className={`font-heading font-bold text-sm min-w-[1.5rem] text-center ${score > 0 ? "text-emerald-400" : score < 0 ? "text-[#FF5E7E]" : "text-slate-300"}`}
      >
        {score}
      </span>
      <button
        data-testid={`downvote-${type}-${item.id}`}
        disabled={busy}
        onClick={(e) => { e.preventDefault(); cast(-1); }}
        className={`p-1 rounded-md transition-colors ${myVote === -1 ? "text-[#FF5E7E]" : "text-slate-400 hover:text-[#FF5E7E]"}`}
      >
        <ArrowBigDown className={`w-5 h-5 ${myVote === -1 ? "fill-[#FF5E7E]" : ""}`} />
      </button>
    </div>
  );
}
